import { useTheme } from "next-themes";
import { type ReactNode } from "react";
import { CircleGradient } from "./circle-gradient";

export const IconCircleGradientWrapper = ({
  children,
}: {
  children: ReactNode;
}) => {
  const { theme } = useTheme();

  return (
    <div className="relative flex h-[128px] w-[128px] items-center justify-center">
      <CircleGradient className="absolute" theme={theme} />
      {children}
    </div>
  );
};
